import PropTypes from 'prop-types';
import { Outlet, Navigate } from 'react-router-dom';
import { ROUTE_NAMES, ROUTE_PATHS } from '../../const/routeNames';

// Utils
import { getAccessToken } from '../../utils/serviceUtils';

const AuthorizedRoute = (props) => {
    const { redirectTo, moduleRoutePath = '' } = props;
    const accessToken = getAccessToken();
    const redirectUrl =
        redirectTo || `${moduleRoutePath}${ROUTE_PATHS[ROUTE_NAMES.STATUS]}`;

    return accessToken ? <Outlet /> : <Navigate to={redirectUrl} />;
};

AuthorizedRoute.propTypes = {
    redirectTo: PropTypes.string,
    moduleRoutePath: PropTypes.string,
};

export default AuthorizedRoute;
